import { black, solarGradientReverse } from '../../theme/colors';
import { flowSteps, recordFlowProgress } from '../../utils/recordFlowProgress';

import { Button } from 'react-bootstrap';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import SolarIconDisc from '../Icon/SolarIconDisc';
import { contentfulPropTypes } from '../../propTypes';
import styled from 'styled-components';
import withContentfulTag from '../../utils/withContentfulTag';

const StyledSolarPanel = styled.div`
  bottom: 0;
  position: sticky;
  padding-bottom: 20px;
  text-align: center;
  margin-top: 40px;

  .solar-header {
    border-radius: 20px;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
    font-size: 26px;
    font-weight: bold;
    color: ${black};
    background: ${solarGradientReverse};
    padding: 50px 10px 10px;
  }
  .solar-body {
    border-radius: 20px;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2);
    background: #fff;
    padding: 20px 20px 1px;
  }
`;

const SolarPanel = ({ large, contentful, loading, fetched }) =>
  !loading &&
  fetched && (
    <>
      <StyledSolarPanel>
        <SolarIconDisc top={-43} />
        <div className="solar-header">{contentful.title}</div>
        <div className="solar-body">
          <ReactMarkdown>{contentful.body}</ReactMarkdown>
          <Button
            onClick={async () => {
              await recordFlowProgress(flowSteps.OVERVIEW_SOLAR_PANEL_CTA);
              return (window.location.href = contentful.link);
            }}
            className="w-100">
            {contentful.primaryButtonText}
          </Button>
        </div>
      </StyledSolarPanel>
    </>
  );

SolarPanel.propTypes = {
  ...contentfulPropTypes,
  large: PropTypes.bool,
};

SolarPanel.defaultProps = {
  large: false,
};

export default withContentfulTag(SolarPanel, 'web_app_solar_panel_small');
